import type {
  MessageReport,
  ModerationAction,
  ModerationReportStatus,
  ModerationReportType,
  PaginatedResponse,
  UserReport,
} from '@pulsify/shared'
import { api, unwrap } from '~/shared/lib/rpc'

const MODERATION_PAGE_SIZE = 25

export interface ModerationQueueParams {
  status: ModerationReportStatus
  page: number
}

export interface ResolveModerationReportParams {
  type: ModerationReportType
  id: string
  action: ModerationAction
}

function queryFor({ status, page }: ModerationQueueParams) {
  return { status, page: String(page), pageSize: String(MODERATION_PAGE_SIZE) }
}

export const moderationApi = {
  async listMessageReports(
    params: ModerationQueueParams,
  ): Promise<PaginatedResponse<MessageReport>> {
    const res = await api.api.admin.moderation['message-reports'].$get({ query: queryFor(params) })
    return unwrap<PaginatedResponse<MessageReport>>(res)
  },

  async listUserReports(params: ModerationQueueParams): Promise<PaginatedResponse<UserReport>> {
    const res = await api.api.admin.moderation['user-reports'].$get({ query: queryFor(params) })
    return unwrap<PaginatedResponse<UserReport>>(res)
  },

  async resolve({ type, id, action }: ResolveModerationReportParams): Promise<void> {
    const res =
      type === 'message'
        ? await api.api.admin.moderation['message-reports'][':id'].resolve.$patch({
            param: { id },
            json: { action },
          })
        : await api.api.admin.moderation['user-reports'][':id'].resolve.$patch({
            param: { id },
            json: { action },
          })
    await unwrap(res)
  },
}
